import { useEffect, useState } from "react";
import InputCommon from "components/inputCommon";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import { useAlterarNomeLead } from "../../../../services/api/AppWeb_Lead/alterar-nome";

interface Props {
  closeModal: Function;
  idLead: string | any;
  idLeadCorretor: string | any;
  nomeLead: string | any;
}

const NameForm = (props: Props) => {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const [nome, setNome] = useState(props?.nomeLead);

  const { mutate, isLoading, isSuccess } = useAlterarNomeLead({
    idLeadCorretor:
      props?.idLeadCorretor === undefined ? "" : props?.idLeadCorretor,
    body: {
      idLead: props?.idLead,
      nomeLead: nome,
    },
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
    }
  }, [isSuccess]);

  return (
    <>
      <Styles.ContentModal>
        <Styles.InfoModal style={{ marginBottom: 8 }}>
          O corretor pode <span>alterar</span> o nome do Lead!
        </Styles.InfoModal>
        <Styles.SpaceY space={12} />
        <Styles.Text style={{ margin: "8px 0 0 0" }}>Nome</Styles.Text>
        <InputCommon
          isDisabled={!isCorretor}
          isError={false}
          type="text"
          placeholder="Nome"
          helperText=""
          value={nome}
          onChange={(event: string) => {
            setNome(event);
          }}
        />
      </Styles.ContentModal>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button
            style={{ width: "100%" }}
            variant="outlined"
            onClick={() => {
              props.closeModal();
            }}
          >
            Fechar
          </Styles.Button>
          {isCorretor ? (
            <Styles.SaveButton
              style={{
                width: "100%",
                background: "#4a76fb",
                boxShadow: "none",
                color: "#fff !important",
              }}
              onClick={() => mutate()}
            >
              {isLoading ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
            </Styles.SaveButton>
          ) : null}
        </Styles.FooterDialog>
      </Styles.Footer>
    </>
  );
};

export default NameForm;
